export const SIGNUP_PHONE_INVALID_ERROR = 'Проверьте номер телефона';
